import LoginLayout from "../../shared-components/login-layout/login-layout";
import MobileNumberVerificationForm from "./mobile-number-verification-form/mobile-number-verification-form";

const MobileNumberVerification = () => {
  return (
    <LoginLayout
      title="Verify Mobile Number"
      subTitle="Your mobile number is not verified yet. If the number below is not correct you can add the correct number."
      showBackButton={true}
    >
      <MobileNumberVerificationForm />
    </LoginLayout>
  );
};

export default MobileNumberVerification;
